import { FC, ReactNode } from 'react'
import { SidebarLeftLayout } from 'ict24h-themes-react'
import LeftMenu from '../e-office/modules/e-office-layout/components/LeftMenu.EOfficeLayout'
import dockConfig from '../inner-iframe/dock-config'

const CustomLayout: FC<{ children?: ReactNode }> = ({ children }) => (
  <SidebarLeftLayout menu={<LeftMenu />} headerConfig={null} dock={dockConfig}>
    {children}
  </SidebarLeftLayout>
)

export default CustomLayout
